var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCalendar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 27,
    viewBox: "0 0 24 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20 2.95H23.75V26.75H0.25V2.95H4H4.25V2.7V0.25H6.41667V2.7V2.95H6.66667H17.3333H17.5833V2.7V0.25H19.75V2.7V2.95H20ZM2.41667 24.3V24.55H2.66667H21.3333H21.5833V24.3V10.8V10.55H21.3333H2.66667H2.41667V10.8V24.3ZM2.41667 8.1V8.35H2.66667H21.3333H21.5833V8.1V5.4V5.15H21.3333H2.66667H2.41667V5.4V8.1ZM10.9167 15.95V13.75H13.0833V15.95H10.9167ZM5.58333 15.95V13.75H7.75V15.95H5.58333ZM16.25 15.95V13.75H18.4167V15.95H16.25ZM10.9167 21.35V19.15H13.0833V21.35H10.9167ZM5.58333 21.35V19.15H7.75V21.35H5.58333ZM16.25 21.35V19.15H18.4167V21.35H16.25Z",
    fill: "#060709",
    stroke: "white",
    strokeWidth: 0.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendar);
export default __webpack_public_path__ + "static/media/calendar.17a48df298257d15257f4f9165eaad6a.svg";
export { ForwardRef as ReactComponent };